import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

export const FETCH_JOB_INPUT_TABLE_DATA =
  'jobInputsAdmin/FETCH_JOB_INPUT_TABLE_DATA'
export const [
  FETCH_JOB_INPUT_TABLE_DATA_SUCCESS,
  FETCH_JOB_INPUT_TABLE_DATA_FAILURE,
] = [
  `${FETCH_JOB_INPUT_TABLE_DATA}_SUCCESS`,
  `${FETCH_JOB_INPUT_TABLE_DATA}_FAILURE`,
]

export const FETCH_JOB_WORKFLOWS = 'jobInputsAdmin/FETCH_JOB_WORKFLOWS'
export const [FETCH_JOB_WORKFLOWS_SUCCESS, FETCH_JOB_WORKFLOWS_FAILURE] = [
  `${FETCH_JOB_WORKFLOWS}_SUCCESS`,
  `${FETCH_JOB_WORKFLOWS}_FAILURE`,
]

export const FETCH_JOB_WORKFLOW_TASKS =
  'jobInputsAdmin/FETCH_JOB_WORKFLOW_TASKS'
export const [
  FETCH_JOB_WORKFLOW_TASKS_SUCCESS,
  FETCH_JOB_WORKFLOW_TASKS_FAILURE,
] = [
  `${FETCH_JOB_WORKFLOW_TASKS}_SUCCESS`,
  `${FETCH_JOB_WORKFLOW_TASKS}_FAILURE`,
]

export const FETCH_JOB_WORKFLOW_INPUT_GROUPS =
  'jobInputsAdmin/FETCH_JOB_WORKFLOW_INPUT_GROUPS'
export const [
  FETCH_JOB_WORKFLOW_INPUT_GROUPS_SUCCESS,
  FETCH_JOB_WORKFLOW_INPUT_GROUPS_FAILURE,
] = [
  `${FETCH_JOB_WORKFLOW_INPUT_GROUPS}_SUCCESS`,
  `${FETCH_JOB_WORKFLOW_INPUT_GROUPS}_FAILURE`,
]

export const FETCH_INPUT_TYPES = 'jobInputsAdmin/FETCH_INPUT_TYPES'
export const [FETCH_INPUT_TYPES_SUCCESS, FETCH_INPUT_TYPES_FAILURE] = [
  `${FETCH_INPUT_TYPES}_SUCCESS`,
  `${FETCH_INPUT_TYPES}_FAILURE`,
]

export const FETCH_TASK_NUMBER_INPUTS =
  'jobInputsAdmin/FETCH_TASK_NUMBER_INPUTS'
export const [
  FETCH_TASK_NUMBER_INPUTS_SUCCESS,
  FETCH_TASK_NUMBER_INPUTS_FAILURE,
] = [
  `${FETCH_TASK_NUMBER_INPUTS}_SUCCESS`,
  `${FETCH_TASK_NUMBER_INPUTS}_FAILURE`,
]

export const FETCH_JOB_WORKFLOW_INPUT_ITEM =
  'jobInputsAdmin/FETCH_JOB_WORKFLOW_INPUT_ITEM'
export const [
  FETCH_JOB_WORKFLOW_INPUT_ITEM_SUCCESS,
  FETCH_JOB_WORKFLOW_INPUT_ITEM_FAILURE,
] = [
  `${FETCH_JOB_WORKFLOW_INPUT_ITEM}_SUCCESS`,
  `${FETCH_JOB_WORKFLOW_INPUT_ITEM}_FAILURE`,
]

export const FETCH_INPUTS_OPTIONS_SOURCE =
  'jobInputsAdmin/FETCH_INPUTS_OPTIONS_SOURCE'
export const [
  FETCH_INPUTS_OPTIONS_SOURCE_SUCCESS,
  FETCH_INPUTS_OPTIONS_SOURCE_FAILURE,
] = [
  `${FETCH_INPUTS_OPTIONS_SOURCE}_SUCCESS`,
  `${FETCH_INPUTS_OPTIONS_SOURCE}_FAILURE`,
]

export const FETCH_LOOKUP_TABLES_SOURCE =
  'jobInputsAdmin/FETCH_LOOKUP_TABLES_SOURCE'
export const [
  FETCH_LOOKUP_TABLES_SOURCE_SUCCESS,
  FETCH_LOOKUP_TABLES_SOURCE_FAILURE,
] = [
  `${FETCH_LOOKUP_TABLES_SOURCE}_SUCCESS`,
  `${FETCH_LOOKUP_TABLES_SOURCE}_FAILURE`,
]

export const FETCH_ALLOWED_LOOKUP_COLUMNS =
  'jobInputsAdmin/FETCH_ALLOWED_LOOKUP_COLUMNS'
export const [
  FETCH_ALLOWED_LOOKUP_COLUMNS_SUCCESS,
  FETCH_ALLOWED_LOOKUP_COLUMNS_FAILURE,
] = [
  `${FETCH_ALLOWED_LOOKUP_COLUMNS}_SUCCESS`,
  `${FETCH_ALLOWED_LOOKUP_COLUMNS}_FAILURE`,
]

export const FETCH_LOOKUP_CONDITIONS = 'jobInputsAdmin/FETCH_LOOKUP_CONDITIONS'
export const [
  FETCH_LOOKUP_CONDITIONS_SUCCESS,
  FETCH_LOOKUP_CONDITIONS_FAILURE,
] = [`${FETCH_LOOKUP_CONDITIONS}_SUCCESS`, `${FETCH_LOOKUP_CONDITIONS}_FAILURE`]

export const FETCH_DEPENDENCY_INPUTS = 'jobInputsAdmin/FETCH_DEPENDENCY_INPUTS'
export const [
  FETCH_DEPENDENCY_INPUTS_SUCCESS,
  FETCH_DEPENDENCY_INPUTS_FAILURE,
] = [`${FETCH_DEPENDENCY_INPUTS}_SUCCESS`, `${FETCH_DEPENDENCY_INPUTS}_FAILURE`]

export const SAVE_JOB_INPUTS_INFO = 'jobInputsAdmin/SAVE_JOB_INPUTS_INFO'
export const DELETE_JOB_INPUTS_ITEM = 'jobInputsAdmin/DELETE_JOB_INPUTS_ITEM'
export const JOB_INPUTS_CLEAR_STORE = 'jobInputsAdmin/JOB_INPUTS_CLEAR_STORE'
export const JOB_INPUTS_CLEAR_DETAILS =
  'jobInputsAdmin/JOB_INPUTS_CLEAR_DETAILS'
export const FETCH_JOB_INPUT_POSITION_UPDATE =
  'jobInputsAdmin/FETCH_JOB_INPUT_POSITION_UPDATE'
export const SUCCESS_JOB_INPUT_POSITION_UPDATE =
  'jobInputsAdmin/SUCCESS_JOB_INPUT_POSITION_UPDATE'
export const PATCH_JOB_WORKFLOW_INPUTS =
  'jobInputsAdmin/PATCH_JOB_WORKFLOW_INPUTS'

export const patchJobWorkflowInputs = ActionHelper.createActionObj(
  PATCH_JOB_WORKFLOW_INPUTS,
)
export const fetchJobInputData = ActionHelper.createActionObj(
  FETCH_JOB_INPUT_TABLE_DATA,
)
export const fetchJobWorkflows = ActionHelper.createActionObj(
  FETCH_JOB_WORKFLOWS,
)
export const fetchJobWorkflowTasks = ActionHelper.createActionObj(
  FETCH_JOB_WORKFLOW_TASKS,
)
export const fetchJobWorkflowInputGroups = ActionHelper.createActionObj(
  FETCH_JOB_WORKFLOW_INPUT_GROUPS,
)
export const fetchInputTypes = ActionHelper.createActionObj(FETCH_INPUT_TYPES)
export const fetchTaskNumberInputs = ActionHelper.createActionObj(
  FETCH_TASK_NUMBER_INPUTS,
)
export const fetchJobWorkflowInputItem = ActionHelper.createActionObj(
  FETCH_JOB_WORKFLOW_INPUT_ITEM,
)
export const fetchInputsOptionsSource = ActionHelper.createActionObj(
  FETCH_INPUTS_OPTIONS_SOURCE,
)
export const fetchLookupTablesSource = ActionHelper.createActionObj(
  FETCH_LOOKUP_TABLES_SOURCE,
)
export const fetchAllowedLookupColumns = ActionHelper.createActionObj(
  FETCH_ALLOWED_LOOKUP_COLUMNS,
)
export const fetchLookupConditions = ActionHelper.createActionObj(
  FETCH_LOOKUP_CONDITIONS,
)
export const fetchDependencyInputs = ActionHelper.createActionObj(
  FETCH_DEPENDENCY_INPUTS,
)
export const fetchJobInputPositionUpdate = ActionHelper.createActionObj(
  FETCH_JOB_INPUT_POSITION_UPDATE,
)
export const saveJobInputsInfo = ActionHelper.createActionObj(
  SAVE_JOB_INPUTS_INFO,
)
export const deleteJobInputItem = ActionHelper.createActionObj(
  DELETE_JOB_INPUTS_ITEM,
)
export const jobInputsClearStore = ActionHelper.createActionObj(
  JOB_INPUTS_CLEAR_STORE,
)
export const jobInputsClearDetails = ActionHelper.createActionObj(
  JOB_INPUTS_CLEAR_DETAILS,
)

const initialState = () =>
  fromJS({
    isLoadingTableData: false,
    isLoadingFormData: false,
    tableData: Map({}),
    formData: Map({}),
    jobWorkflows: List([]),
    jobWorkflowTasks: List([]),
    jobWorkflowInputGroups: List([]),
    inputTypes: List([]),
    optionsSource: List([]),
    lookupTablesSource: List([]),
    allowedTableColumns: List([]),
    lookupConditions: List([]),
    dependencyInputs: List([]),
    numberInputs: List([]),
  })

const jobInputsAdmin = handleActions(
  {
    [FETCH_JOB_INPUT_TABLE_DATA]: state =>
      state.set('isLoadingTableData', true),
    [FETCH_JOB_INPUT_TABLE_DATA_SUCCESS]: (state, action) =>
      state
        .set('isLoadingTableData', false)
        .set('tableData', Map(action.payload)),
    [FETCH_JOB_INPUT_TABLE_DATA_FAILURE]: state =>
      state
        .set('isLoadingTableData', false)
        .set('tableData', initialState().get('tableData')),
    [FETCH_JOB_WORKFLOW_INPUT_ITEM]: state =>
      state.set('isLoadingFormData', true),
    [FETCH_JOB_WORKFLOW_INPUT_ITEM_SUCCESS]: (state, action) =>
      state
        .set('isLoadingFormData', false)
        .set('formData', Map(action.payload)),
    [FETCH_JOB_WORKFLOW_INPUT_ITEM_FAILURE]: state =>
      state
        .set('isLoadingFormData', false)
        .set('formData', initialState().get('formData')),
    [FETCH_JOB_WORKFLOWS_SUCCESS]: (state, action) =>
      state.set('jobWorkflows', List(action.payload)),
    [FETCH_JOB_WORKFLOWS_FAILURE]: state =>
      state.set('jobWorkflows', initialState().get('jobWorkflows')),
    [FETCH_JOB_WORKFLOW_TASKS_SUCCESS]: (state, action) =>
      state.set('jobWorkflowTasks', List(action.payload)),
    [FETCH_JOB_WORKFLOW_TASKS_FAILURE]: state =>
      state.set('jobWorkflowTasks', initialState().get('jobWorkflowTasks')),
    [FETCH_JOB_WORKFLOW_INPUT_GROUPS_SUCCESS]: (state, action) =>
      state.set('jobWorkflowInputGroups', List(action.payload)),
    [FETCH_JOB_WORKFLOW_INPUT_GROUPS_FAILURE]: state =>
      state.set(
        'jobWorkflowInputGroups',
        initialState().get('jobWorkflowInputGroups'),
      ),
    [FETCH_INPUT_TYPES_SUCCESS]: (state, action) =>
      state.set('inputTypes', List(action.payload)),
    [FETCH_INPUT_TYPES_FAILURE]: state =>
      state.set('inputTypes', initialState().get('inputTypes')),
    [FETCH_INPUTS_OPTIONS_SOURCE_SUCCESS]: (state, action) =>
      state.set('optionsSource', List(action.payload)),
    [FETCH_INPUTS_OPTIONS_SOURCE_FAILURE]: state =>
      state.set('optionsSource', initialState().get('optionsSource')),
    [FETCH_LOOKUP_TABLES_SOURCE_SUCCESS]: (state, action) =>
      state.set('lookupTablesSource', List(action.payload)),
    [FETCH_LOOKUP_TABLES_SOURCE_FAILURE]: state =>
      state.set('lookupTablesSource', initialState().get('lookupTablesSource')),
    [FETCH_ALLOWED_LOOKUP_COLUMNS_SUCCESS]: (state, action) =>
      state.set('allowedTableColumns', List(action.payload)),
    [FETCH_ALLOWED_LOOKUP_COLUMNS_FAILURE]: state =>
      state.set(
        'allowedTableColumns',
        initialState().get('allowedTableColumns'),
      ),
    [FETCH_LOOKUP_CONDITIONS_SUCCESS]: (state, action) =>
      state.set('lookupConditions', List(action.payload)),
    [FETCH_LOOKUP_CONDITIONS_FAILURE]: state =>
      state.set('lookupConditions', initialState().get('lookupConditions')),
    [FETCH_DEPENDENCY_INPUTS_SUCCESS]: (state, action) =>
      state.set('dependencyInputs', List(action.payload)),
    [FETCH_TASK_NUMBER_INPUTS_SUCCESS]: (state, action) =>
      state.set('numberInputs', List(action.payload)),
    [FETCH_DEPENDENCY_INPUTS_FAILURE]: state =>
      state.set('dependencyInputs', initialState().get('dependencyInputs')),
    [SUCCESS_JOB_INPUT_POSITION_UPDATE]: (
      state,
      { payload: { index, position } },
    ) => {
      const { data, count } = state.get('tableData').toJS()
      data[index].position = position

      return state.set(
        'tableData',
        Map({
          data,
          count,
        }),
      )
    },

    [JOB_INPUTS_CLEAR_DETAILS]: state =>
      state.set('formData', initialState().get('formData')),
    [JOB_INPUTS_CLEAR_STORE]: () => initialState(),
  },
  initialState(),
)

export default jobInputsAdmin
